module.exports = __webpack_public_path__ + "static/img/oilApplication6.f799b0a7.png";